import app from '../../config/configApp';
import VueUploadComponent from 'vue-upload-component';

app.component('file-upload', VueUploadComponent);
